import { alpha } from '@material-ui/core/styles';

export const backdrop = ((theme) => ({
  MuiBackdrop: {
    root: { backgroundColor: alpha(theme.palette.common.black, 0.6) },
  }
}));
